import { PresenceDay } from "./attendance-cau.model";

export class UpdateStudentAttendance {
    serviceId: number;
    year: number;
    month: number;
    studentId: number;
    presenceDays: PresenceDay[];
}

export class UpdateStudentAttendanceMassive {
    serviceId: number;
    year: number;
    month: number;
    schoolId: number;
    exerciseId: number;
    updatePresenceStudentCAUs: UpdateAttendanceStudentRequest[];
}

export class UpdateAttendanceStudentRequest {
    studentId: number;
    studentName: string;
    presenceDays: PresenceDay[];
    constructor(
      studentId: number,
      studentName: string,
      presenceDays: PresenceDay[]
    ) {
      this.studentId = studentId;
      this.studentName = studentName;
      this.presenceDays = presenceDays;
    }
  }